import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { Carousel } from '@platzi/ui';
import { TitleSection } from '../';
import styles from './LiveEvents.module.sass';

export const LiveEvents = () => {
  const Mock = new Array(6).fill('');
  const elementsByBreakpoint = { xs: 1, sm: 2, md: 3, lg: 3 };

  const renderCards = () => {
    return Mock.map((item, index) => <div key={`SchoolLiveEvent-${index}`}>Live Event</div>);
  };

  return (
    <div className={styles.LiveEvents}>
      <TitleSection title="Live Events">
        <a className={styles.Link} href="?">
          Ir a Eventos <FontAwesomeIcon icon={faArrowRight} />
        </a>
      </TitleSection>
      <Carousel numberOfElements={elementsByBreakpoint} elements={renderCards()} />
    </div>
  );
};
